var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-alert',{attrs:{"type":"error","dense":""},model:{value:(_vm.hasError),callback:function ($$v) {_vm.hasError=$$v},expression:"hasError"}},[_c('v-row',[_c('v-col',{staticClass:"grow"},[_vm._v(" Whoops, something went wrong ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }